import { NgModule } from '@angular/core';

import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';

import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  NgxMatDatetimePickerModule,
  NgxMatNativeDateModule,
  NgxMatTimepickerModule,
} from '@angular-material-components/datetime-picker';
import { NgxMatFileInputModule } from '@angular-material-components/file-input';

@NgModule({
  exports: [
    A11yModule,
    DragDropModule,
    PortalModule,
    ScrollingModule,
    CdkStepperModule,
    CdkTableModule,
    CdkTreeModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule,
    NgxMatFileInputModule,
  ],
})
export class MaterialModule {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {
    this.matIconRegistry.addSvgIcon(
      'sgv_qr_code',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/qr_code-black-48dp.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_text_snippet',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/text_snippet-black-18dp.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_facebook',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/facebook.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_instagram',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/instagram.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_twitter',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/twitter.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_youtube',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/youtube.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_whatsapp',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/whatsapp.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_shirt',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/shirt.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_shorts',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/shorts.svg'
      )
    );
    this.matIconRegistry.addSvgIcon(
      'svg_socks',
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        environment.assetsUrl + 'assets/icons/socks.svg'
      )
    );
    // Or whatever path you placed mdi.svg at
  }
}
